import { apiRequest } from "../client";
import type { SnapshotData, SnapshotRequest } from "./types";
import type { ApiResponse } from "../types";

/**
 * Get snapshot data for resources.
 *
 * @param request - The snapshot request configuration
 * @returns The snapshot data, or null if the resource exists but has no snapshots yet
 */
export const getSnapshotData = async (
  request?: SnapshotRequest
): Promise<SnapshotData | null> => {
  const response = await apiRequest<ApiResponse<SnapshotData | null>>({
    method: "POST",
    url: `/data/snapshot`,
    data: request,
  });

  if (response.status === "error") {
    throw new Error(
      response.error?.message || "Failed to fetch snapshot data"
    );
  }

  // Return null when resource exists but has no snapshots yet
  return response.data ?? null;
};
